import React from 'react';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import useScreen from 'hooks/useScreen';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import RealEstateAgentPresenter from 'presenters/RealEstateAgentPresenter';
import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const FavoriteLoanOfficersList = props => {
  const { loanOfficers, realEstateAgent } = props;
  const { isDesktop } = useScreen();
  const classes = useStyles();
  const { t } = useTranslation();

  const possessiveName = RealEstateAgentPresenter.possessiveName(realEstateAgent);

  return (
    <div className={classes.container}>
      {isDesktop && (
        <Typography className={classes.header} variant="h1">
          {t('components.ReferralRealEstateAgent.FavoriteLoanOfficersList.header', { possessiveName })}
        </Typography>
      )}
      <div>
        {loanOfficers.map(loanOfficer => (
          <LoanOfficerCard key={loanOfficer.id} loanOfficer={loanOfficer} />
        ))}
        {isBlank(loanOfficers) && (
          <Typography className={classes.emptyLabel} variant="subtitle1">
            {t('components.ReferralRealEstateAgent.FavoriteLoanOfficersList.noLoanOfficers')}
          </Typography>
        )}
      </div>
    </div>
  );
};

FavoriteLoanOfficersList.propTypes = {
  loanOfficers: PropTypes.arrayOf(PropTypes.shape()),
  realEstateAgent: RealEstateAgentPresenter.shape().isRequired,
};

FavoriteLoanOfficersList.defaultProps = {
  loanOfficers: [],
};

export default FavoriteLoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/FavoriteLoanOfficersList/FavoriteLoanOfficersList.js